import ProductAuthorModalList from "./product-author-modal-list";

export default ProductAuthorModalList;